import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Books from './pages/Books';
import NemiaCh1 from "./pages/read/NemiaCh1";
import Shorts1 from "./pages/read/Shorts1";

import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/books" element={<Books />} />
        {/* reader magnets */}
        <Route path="/read/NemiaCh1" element={<NemiaCh1 />} />
        <Route path="/read/Shorts1" element={<Shorts1 />} />
      </Routes>
    </Router>
  );
}

export default App;

